import { useState, useEffect, useMemo } from 'react';
import { flushSync } from "react-dom";
import { Row, Col, Card, CardBody, CardHeader, Table, Collapse} from 'reactstrap';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import './RiskMap.css';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { FaChevronUp, FaChevronDown} from 'react-icons/fa';
import uuid from 'react-uuid';
import MapView from '../Map/MapView';
import ToggleSwitch from '../ThreeStateToggle/ToggleSwitch';
import RiskMapItemView from './RiskMapItemView';
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";


const RiskMap = (handleWizardChanged) => {
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [loading, setLoading] = useState(true); const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0 })
    const [mapDetails, setMapDetails] = useState({
        isRiskmapPage: true, isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false, isFarmOutlineEditable: false, zoomLevel: 15,
        polytype: '', highlighteditemId: 0
    });
    const [itemList, setItemList] = useState([]);
    const [riskMap, setRiskMap] = useState({ outlineList: [], itemList: [], SectionName: 'Risk Map', Section: 'Risk Map', isWizardCompleted: false });
    const [isRiskOpen, setIsRiskOpen] = useState(false);
    const [isRiskIconUp, setIsRiskIconUp] = useState(false);
    const [isMitigatedOpen, setIsMitigatedOpen] = useState(false);
    const [isMitigatedIconUp, setIsMitigatedIconUp] = useState(false);
    const [isEnhancementOpen, setIsEnhancementOpen] = useState(false);
    const [isEnhancementIconUp, setIsEnhancementIconUp] = useState(false);
    const toggleRisk = () => {
        setIsRiskOpen(!isRiskOpen)
        setIsRiskIconUp(!isRiskIconUp)
    };
    const toggleMitigated = () => {
        setIsMitigatedOpen(!isMitigatedOpen)
        setIsMitigatedIconUp(!isMitigatedIconUp)
    };
    const toggleEnhancement = () => {
        setIsEnhancementOpen(!isEnhancementOpen)
        setIsEnhancementIconUp(!isEnhancementIconUp)
    }; const [sectionList, setSectionList] = useState([]);
    const [tempItemList, setTempItemList] = useState([]);
    const [chkHideRiskItems, setChkHideRiskItems] = useState(false);
    const [chkAllMitigated, setChkAllMitigated] = useState(false);
    const [chkAllEnhancement, setChkAllEnhancement] = useState(false);
    const [riskHeader, setRiskHeader] = useState('');
    const [mitigatedHeader, setMitigatedHeader] = useState('');
    const [enhancementHeader, setEnhancementHeader] = useState('');

    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/riskmap/GetRiskMap/', {
                params: {
                    farmId: farmId
                }
            }
            );
            var riskItems = response.data.riskItemList.filter(x => x.itemActions.riskResult == "R");
            var enhancementItems = response.data.riskItemList.filter(x => x.itemActions.riskResult == "E");
            var mapItemList = [];
            riskItems.forEach((value1, key1) => {
                mapItemList.push(value1);
            });
            enhancementItems.forEach((value1, key1) => {
                mapItemList.push(value1);
            });
            setRiskMap({ ...riskMap, outlineList: response.data.outlineList, itemList: mapItemList, isWizardCompleted: response.data.isFWFPCompleted });
            setItemList(mapItemList);
            setTempItemList(response.data.riskItemList);
            setSectionList(response.data.riskMapSectionsList);
            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel });
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.islargeEnterprise, LMUList: response.data.lmuItemList })
            setLoading(false);
            setChkAllMitigated(true);
            hideItemsOnLoad(response.data.riskMapSectionsList, response.data.riskItemList);
        } catch (err) {
            console.log(err);
        }
    }

    const hideRiskItems = async (e) => {
        setChkHideRiskItems(e.target.checked);
        hideItems();
    }

    const hideAllMitigated = async (e) => {
        setChkAllMitigated(e.target.checked);
        hideItems();
    }

    const hideAllEnhancement = async (e) => {
        setChkAllEnhancement(e.target.checked);
        hideItems();
    }

    const showHideRiskMapItem = async (e, item1) => {
        let tempList = sectionList;
        tempList.map((sectionList) => {
            if (sectionList.name === item1.name) {
                sectionList.checked = e.target.checked;
            }
            return sectionList;
        });

        flushSync(() => {
            setSectionList(prevSectionList => {
                const newSectionList = [...prevSectionList];
                return newSectionList;
            });
        });
        hideItems();
    }

    function hideItems() {
        let tempList = sectionList;
        let tempItems = [];
        tempList.forEach((value, key) => {
            if (value.checked) {
                tempItemList.filter(x => x.sectionName == value.displayName).forEach((value1, key1) => {
                    tempItems.push(value1);
                });
            }
        });
        let tempFilteredItems1 = [];
        if (!document.getElementById('chkHideRiskItems').checked) {
            tempItems.filter(x => x.itemActions.riskResult == "R").forEach((value1, key1) => {
                tempFilteredItems1.push(value1);
            });
        }
        if (!document.getElementById('chkAllMitigated').checked) {
            tempItems.filter(x => x.itemActions.riskResult == "M").forEach((value1, key1) => {
                tempFilteredItems1.push(value1);
            });
        }
        if (!document.getElementById('chkAllEnhancement').checked) {
            tempItems.filter(x => x.itemActions.riskResult == "E").forEach((value1, key1) => {
                tempFilteredItems1.push(value1);
            });
        }
        var riskItems = tempFilteredItems1.filter(x => x.itemActions.riskResult == "R").length;
        setRiskHeader(riskItems + ' Item(s)');
        var mitigatedItems = tempFilteredItems1.filter(x => x.itemActions.riskResult == "M").length;
        setMitigatedHeader(mitigatedItems + ' Item(s)');
        var enhancementItems = tempFilteredItems1.filter(x => x.itemActions.riskResult == "E").length;
        setEnhancementHeader(enhancementItems + ' Item(s)');
        setItemList(tempFilteredItems1);
        setRiskMap({ ...riskMap, itemList: tempFilteredItems1 });
    }

    function hideItemsOnLoad(sectionList, tempItemList) {
        let tempList = sectionList;
        let tempItems = [];
        tempList.forEach((value, key) => {
            if (value.checked) {
                tempItemList.filter(x => x.sectionName == value.displayName).forEach((value1, key1) => {
                    tempItems.push(value1);
                });
            }
        });
        let tempFilteredItems = [];
        tempItems.filter(x => x.itemActions.riskResult == "R").forEach((value1, key1) => {
            tempFilteredItems.push(value1);
        });
        tempItems.filter(x => x.itemActions.riskResult == "E").forEach((value1, key1) => {
            tempFilteredItems.push(value1);
        });
        var riskItems = tempFilteredItems.filter(x => x.itemActions.riskResult == "R").length;
        setRiskHeader(riskItems + ' Item(s)');
        var mitigatedItems = tempFilteredItems.filter(x => x.itemActions.riskResult == "M").length;
        setMitigatedHeader(mitigatedItems + ' Item(s)');
        var enhancementItems = tempFilteredItems.filter(x => x.itemActions.riskResult == "E").length;
        setEnhancementHeader(enhancementItems + ' Item(s)');
    }

    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    const mapView = useMemo(() => {
        return (
            <MapView
                itemModel={riskMap}
                mapDetails={mapDetails}
                largeEnterpriseDetails={largeEnterpriseDetails}>
            </MapView>
        )
    }, [riskMap, mapDetails, largeEnterpriseDetails])

    const riskItemView = useMemo(() => {
        return (
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th style={{ width: "10%" }}></th>
                        <th style={{ width: "20%" }}>Item Title</th>
                        <th style={{ width: "20%" }}>Page</th>
                        <th style={{ width: "25%" }}>Item Type</th>
                        <th style={{ width: "15%" }}>Open Actions</th>
                        <th style={{ width: "10%" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {itemList.filter(x => x.itemActions.riskResult == "R") != undefined && itemList.filter(x => x.itemActions.riskResult == "R") != null && itemList.filter(x => x.itemActions.riskResult == "R").map(item => (
                        <RiskMapItemView key={uuid()} item={item} handleItemHighlight={handleItemHighlight}></RiskMapItemView>
                    ))}
                </tbody>
            </Table>
        )
    }, [itemList])

    const mitigatedItemView = useMemo(() => {
        return (
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th style={{ width: "10%" }}></th>
                        <th style={{ width: "20%" }}>Item Title</th>
                        <th style={{ width: "20%" }}>Page</th>
                        <th style={{ width: "25%" }}>Item Type</th>
                        <th style={{ width: "15%" }}>Open Actions</th>
                        <th style={{ width: "10%" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {itemList.filter(x => x.itemActions.riskResult == "M") != undefined && itemList.filter(x => x.itemActions.riskResult == "M") != null && itemList.filter(x => x.itemActions.riskResult == "M").map(item => (
                        <RiskMapItemView key={uuid()} item={item} handleItemHighlight={handleItemHighlight}></RiskMapItemView>
                    ))}
                </tbody>
            </Table>
        )
    }, [itemList])

    const enhancementItemView = useMemo(() => {
        return (
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th style={{ width: "10%" }}></th>
                        <th style={{ width: "20%" }}>Item Title</th>
                        <th style={{ width: "20%" }}>Page</th>
                        <th style={{ width: "25%" }}>Item Type</th>
                        <th style={{ width: "15%" }}>Open Actions</th>
                        <th style={{ width: "10%" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {itemList.filter(x => x.itemActions.riskResult == "E") != undefined && itemList.filter(x => x.itemActions.riskResult == "E") != null && itemList.filter(x => x.itemActions.riskResult == "E").map(item => (
                        <RiskMapItemView key={uuid()} item={item} handleItemHighlight={handleItemHighlight}></RiskMapItemView>
                    ))}
                </tbody>
            </Table>
        )
    }, [itemList])

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h2>{riskMap.SectionName}</h2></Col>
            </Row>
            {
                loading ? <SpinnerContainer /> :
                    <div>
                        <Row>
                            <div style={{ textAlign: '-webkit-center' }}>
                                <Col>
                                    <ToggleSwitch values={['map', 'map & details', 'details']} selected='map & details' />
                                </Col>
                            </div>
                        </Row>
                        <Row style={{ marginTop: '10px' }}>
                            <Col id='mapView'>
                                {mapView}
                            </Col>
                            <Col id='nonMapView'>
                                <Card>
                                    <CardHeader className="header">
                                        <Row>
                                            <Col sm="6"><span className="text-uppercase fw-bold color-dark-teal">Risk Map</span></Col>
                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col sm="4">
                                                <span className="riskTypes"><img className="risk-image" src="/images/Risk-image.png" alt="" title="Risk" /> Risk</span>
                                            </Col>
                                            <Col sm="4">
                                                <span className="riskTypes"><img className="risk-image" src="/images/Mitigated-Risk-image.png" alt="" title="Mitigated Risk" /> Mitigated Risk</span>
                                            </Col>
                                            <Col sm="4">
                                                <span className="riskTypes"><img className="risk-image" src="/images/Enhancement.png" alt="" title="Enhancement" /> Enhancement</span>
                                            </Col>
                                            <hr style={{ color: "#ccc !important", marginTop: 20, marginBottom: 20, border: 0, borderTop: "1px solid #ccc" }} />
                                        </Row>
                                        <Row>
                                            <Col sm="4">
                                                <input type="checkbox" className="riskmapCheck1" style={{ verticalAlign: "middle" }} checked={chkHideRiskItems} id="chkHideRiskItems" name="chkHideRiskItems" onChange={hideRiskItems} /> Hide All Risk Items
                                            </Col>
                                            <Col sm="4">
                                                <input type="checkbox" className="riskmapCheck1" style={{ verticalAlign: "middle" }} checked={chkAllMitigated} id="chkAllMitigated" name="chkAllMitigated" onChange={hideAllMitigated} /> Hide All Mitigated
                                            </Col>
                                            <Col sm="4">
                                                <input type="checkbox" className="riskmapCheck1" style={{ verticalAlign: "middle" }} checked={chkAllEnhancement} id="chkAllEnhancement" name="chkAllEnhancement" onChange={hideAllEnhancement} /> Hide All Enhancement
                                            </Col>
                                        </Row>
                                        <br />
                                        <Row>
                                            <Col>
                                                <span className="risk-showlabel">Show items from page(s)</span>
                                            </Col>
                                        </Row>
                                        <br />
                                        <Row>
                                            {sectionList != undefined && sectionList != null && sectionList.map(item => (
                                                <Col key={uuid()} sm="4">
                                                    <input type="checkbox" className="riskmapCheck" id={"chk_" + item.name} name={"chk_" + item.name} checked={item.checked}
                                                        onChange={(e) => showHideRiskMapItem(e, item)} />{" "}
                                                    {item.displayName}
                                                </Col>
                                            ))}
                                        </Row>
                                        {!chkHideRiskItems && <div>
                                            <br />
                                            <Row>
                                                <Col>
                                                    <Card>
                                                        <CardHeader className="item-header" onClick={toggleRisk}>
                                                            <Row>
                                                                <Col sm="11"><span className="text-uppercase fw-bold color-dark-teal">Risk <span className="item-summary-riskmap">{riskHeader}</span></span></Col>
                                                                <Col sm="1" className="toggleoutline">{isRiskIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                                            </Row>
                                                        </CardHeader>
                                                        <Collapse isOpen={isRiskOpen}>
                                                            <CardBody>
                                                                {riskItemView}
                                                            </CardBody>
                                                        </Collapse>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </div>}
                                        {!chkAllMitigated && <div>
                                            <br />
                                            <Row>
                                                <Col>
                                                    <Card>
                                                        <CardHeader className="item-header" onClick={toggleMitigated}>
                                                            <Row>
                                                                <Col sm="11"><span className="text-uppercase fw-bold color-dark-teal">Mitigated Risk<span className="item-summary-riskmap">{mitigatedHeader}</span></span></Col>
                                                                <Col sm="1" className="toggleoutline">{isMitigatedIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                                            </Row>
                                                        </CardHeader>
                                                        <Collapse isOpen={isMitigatedOpen}>
                                                            <CardBody>
                                                                {mitigatedItemView}
                                                            </CardBody>
                                                        </Collapse>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </div>}
                                        {!chkAllEnhancement && <div>
                                            <br />
                                            <Row>
                                                <Col>
                                                    <Card>
                                                        <CardHeader className="item-header" onClick={toggleEnhancement}>
                                                            <Row>
                                                                <Col sm="11"><span className="text-uppercase fw-bold color-dark-teal">Enhancement<span className="item-summary-riskmap">{enhancementHeader}</span></span></Col>
                                                                <Col sm="1" className="toggleoutline">{isEnhancementIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                                            </Row>
                                                        </CardHeader>
                                                        <Collapse isOpen={isEnhancementOpen}>
                                                            <CardBody>
                                                                {enhancementItemView}
                                                            </CardBody>
                                                        </Collapse>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </div>}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                    
            }
        </div>
    )
}
export default RiskMap;